import { render, staticRenderFns } from "./BookingDetailsTime.vue?vue&type=template&id=15bcdcc4&"
import script from "./BookingDetailsTime.vue?vue&type=script&lang=js&"
export * from "./BookingDetailsTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports